import { Column } from "primereact/column";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import React, { useState, useEffect, useRef } from "react";
import "../styles/Turmeric.css";
import { FaEye, FaMagnet } from "react-icons/fa";
import {
  FiEye,
  FiLayers,
  FiShield,
  FiShoppingBag,
  FiCalendar,
} from "react-icons/fi";
import { CheckCircle, XCircle } from "react-bootstrap-icons";
import InfoHeader from "../components/InfoHeader";
import { Carousel, Modal } from "react-bootstrap";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import { downloadCleaningActivityExcelTurmeric, fetchTurmericHistory, fetchTurmericSummary, fetchCleaningActivityDataTurmeric, saveActualCount } from "../components/API/Api";
import UnsafeEventsModal from "../components/UnsafeEventsModal";
import { FaHistory } from "react-icons/fa";
import { SiTraefikmesh } from "react-icons/si";
import CleaningHistoryModal from "../components/MagneticGrillCleanModal";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const RowSaveButton = ({ rowKey, saveCallbacksRef, onSave, hasExistingValue }) => {
  const [enabled, setEnabled] = useState(!!hasExistingValue);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [isUpdate, setIsUpdate] = useState(!!hasExistingValue);

  useEffect(() => {
    saveCallbacksRef.current[rowKey] = (hasValue) => setEnabled(hasValue);
    return () => { delete saveCallbacksRef.current[rowKey]; };
  }, [rowKey, saveCallbacksRef]);

  const handleClick = async () => {
    setSaving(true);
    const success = await onSave();
    setSaving(false);
    if (success) {
      setSaved(true);
      setIsUpdate(true);
      setTimeout(() => setSaved(false), 2000);
    }
  };

  return (
    <button
      disabled={!enabled || saving}
      onClick={handleClick}
      style={{
        padding: "4px 10px",
        fontSize: "12px",
        border: "none",
        borderRadius: "4px",
        cursor: enabled && !saving ? "pointer" : "not-allowed",
        backgroundColor: saved ? "#28a745" : enabled ? "#0d6efd" : "#ccc",
        color: "#fff",
        minWidth: "55px",
      }}
    >
      {saving ? "..." : saved ? "\u2713" : isUpdate ? "Update" : "Save"}
    </button>
  );
};

function Turmeric() {
  const [isHopper1, setIsHopper1] = useState(true);
  const [modal, setModal] = useState(true);
  const [loading, setLoading] = useState(false);

  // Initialize date range with current date
  const today = new Date();
  const [dateRange, setDateRange] = useState([today, today]);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    rowsPerPage: 10,
  });

  const [shiftFilter, setShiftFilter] = useState("");
  const actualCountsRef = useRef({});
  const saveCallbacksRef = useRef({});

  const handleActualCountChange = (key, value) => {
    actualCountsRef.current[key] = value;
    if (saveCallbacksRef.current[key]) saveCallbacksRef.current[key](!!value);
  };

  const handleSaveActualCount = async (rowData) => {
    const key = `${rowData.date}_${rowData.time}`;
    const actualCount = actualCountsRef.current[key];
    if (!actualCount) {
      alert("Please enter an actual count before saving");
      return false;
    }
    try {
      const payload = {
        section: isHopper1 ? "turmeric#hopper1#hourly#count" : "turmeric#hopper2#hourly#count",
        date: rowData.date,
        time: rowData.time,
        shift: rowData.shift,
        actual_sack_count: Number(actualCount) || 0,
      };
      const response = await saveActualCount(payload);
      if (response.success) {
        setData(prev => prev.map(item =>
          `${item.date}_${item.time}` === key
            ? { ...item, actual_sack_count: Number(actualCount) || 0 }
            : item
        ));
        return true;
      } else {
        alert(response.error || "Failed to save actual count");
        return false;
      }
    } catch (err) {
      alert("Error saving actual count: " + err.message);
      return false;
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [cleaning_image, setCleaningImage] = useState(null)
  const [currentRtcComponent, setCurrentRtcComponent] = useState("premixer1");
  const [showCleaningHistoryModal, setShowCleaningHistoryModal] = useState(false);
  const [showTurmericModal, setShowTurmericModal] = useState(false);
  const [currentCleaningComponent, setCurrentCleaningComponent] = useState(null);
  const [currentCleaningType, setCurrentCleaningType] = useState(null);

  const [apiMetrics, setApiMetrics] = useState({
    totalSackCount: 0,
    totalThreadCount: 0,
    lastThreadTimestamp: null,
  });

  const [displayMetrics, setDisplayMetrics] = useState({
    totalSackCount: 0,
    totalThreadCount: 0,
    lastThreadTimestamp: null,
  });

  const [turmericCleaningHistory, setTurmericCleaningHistory] = useState({
    hopper1: [],
    hopper2: []
  });

  // Metrics data state
  const [metrics, setMetrics] = useState({
    hopper1: {
      sackCount: "0",
      grillCleaningTime: "No data",
      grillCleaningImage: null,
      grillStatus: { status: false, displayText: "Unknown", isLidClose: false },
      meshStatus: { status: false, displayText: "Unknown", isLidClose: false },
      lidPresence: null,
      unsafeEvents: []
    },
    hopper2: {
      sackCount: "0",
      grillCleaningTime: "No data",
      grillCleaningImage: null,
      grillStatus: { status: false, displayText: "Unknown", isLidClose: false },
      meshStatus: { status: false, displayText: "Unknown", isLidClose: false },
      lidPresence: null,
      unsafeEvents: []
    },
  });

  const [currentHopper, setCurrentHopper] = useState("hopper1");
  const [showUnsafeModal, setShowUnsafeModal] = useState(false);
  const [showCleaningModal, setShowCleaningModal] = useState(false);
  const [unsafeEvents, setUnsafeEvents] = useState({
    hopper1: [],
    hopper2: [],
  });

  const formatDateForAPI = (date) => {
    if (!date) return "";
    const dateCopy = new Date(date);
    const year = dateCopy.getFullYear();
    const month = String(dateCopy.getMonth() + 1).padStart(2, '0');
    const day = String(dateCopy.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleDownloadExcel = async () => {
    try {
      setLoading(true);

      const startDate = dateRange[0] ? formatDateForAPI(dateRange[0]) : null;
      const endDate = dateRange[1] ? formatDateForAPI(dateRange[1]) : null;

      if (!startDate || !endDate) {
        setError('Please select a valid date range');
        return;
      }

      // Fetch data
      const result = await fetchCleaningActivityDataTurmeric({
        startDate: startDate,
        endDate: endDate,
        section: "turmeric"
      });

      let data;
      if (result?.body?.success?.data) {
        data = result.body.success.data;
      } else if (result?.data) {
        data = result.data;
      } else if (result?.body?.data) {
        data = result.body.data;
      } else {
        setError("No data received from server");
        return;
      }

      if (!data) {
        setError("No data received from server");
        return;
      }

      // Create workbook
      const workbook = XLSX.utils.book_new();

      // Process hopper1 and hopper2 separately
      ['hopper1', 'hopper2'].forEach(hopperKey => {
        let hopperRecords = data[hopperKey];

        if (!hopperRecords || hopperRecords.length === 0) {
          console.warn(`No records found for ${hopperKey}`);
          const emptySheet = XLSX.utils.json_to_sheet([{
            'Sr. No.': 'No data available',
            Date: 'No data available',
            Time: 'No data available',
            Image: 'No data available'
          }]);
          XLSX.utils.book_append_sheet(
            workbook,
            emptySheet,
            hopperKey === 'hopper1' ? 'Hopper1' : 'Hopper2'
          );
          return;
        }

        const formattedRecords = hopperRecords.map((record, index) => ({
          'Sr. No.': index + 1,
          Date: record.Date,        // Direct API field
          Time: record.Time,        // Direct API field  
          Image: record.Image,      // Direct API field
          Hopper: hopperKey
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedRecords);

        // Set column widths
        const colWidths = [
          { wch: 8 },  // Sr. No.
          { wch: 12 }, // Date
          { wch: 15 }, // Time
          { wch: 60 }, // Image URL
          { wch: 10 }  // Hopper
        ];
        worksheet['!cols'] = colWidths;

        // Add sheet to workbook
        const sheetName = hopperKey === 'hopper1' ? 'Hopper1' : 'Hopper2';
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      });

      // Generate and save file
      const wbout = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const filename = `Turmeric_Cleaning_Activity_${startDate}_to_${endDate}.xlsx`;
      saveAs(blob, filename);

      console.log('Excel file downloaded successfully');

    } catch (error) {
      console.error('Error downloading Excel file:', error);
      setError('Failed to download Excel file. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadUnsafeEventsExcel = () => {
    try {
      const startDate = dateRange[0] ? formatDateForAPI(dateRange[0]) : null;
      const endDate = dateRange[1] ? formatDateForAPI(dateRange[1]) : null;

      if (!startDate || !endDate) {
        setError('Please select a valid date range');
        return;
      }

      const workbook = XLSX.utils.book_new();

      ['hopper1', 'hopper2'].forEach(hopperKey => {
        const events = metrics[hopperKey]?.unsafeEvents || [];

        if (!events || events.length === 0) {
          const emptySheet = XLSX.utils.json_to_sheet([{
            'Sr. No.': 'No data available',
            Date: '',
            Time: '',
            Status: '',
            Image: ''
          }]);
          XLSX.utils.book_append_sheet(
            workbook,
            emptySheet,
            hopperKey === 'hopper1' ? 'Hopper1' : 'Hopper2'
          );
          return;
        }

        const formattedRecords = events.map((event, index) => {
          const date = new Date(event.timestamp);
          const dateStr = !isNaN(date)
            ? date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
            : '';
          const timeStr = !isNaN(date)
            ? date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
            : '';

          return {
            'Sr. No.': index + 1,
            Date: dateStr,
            Time: timeStr,
            Status: event.status === 'present' ? 'Present' : 'Absent',
            Image: event.file_name || ''
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedRecords);
        worksheet['!cols'] = [
          { wch: 8 },   // Sr. No.
          { wch: 15 },  // Date
          { wch: 12 },  // Time
          { wch: 12 },  // Status
          { wch: 60 }   // Image URL
        ];

        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          hopperKey === 'hopper1' ? 'Hopper1' : 'Hopper2'
        );
      });

      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const filename = `Turmeric_Unsafe_Events_${startDate}_to_${endDate}.xlsx`;
      saveAs(blob, filename);
    } catch (error) {
      console.error('Error downloading unsafe events Excel:', error);
      setError('Failed to download unsafe events Excel file. Please try again.');
    }
  };

  const formatIfTimestamp = (
    val,
    options = { showDate: true, showTime: true }
  ) => {
    if (
      typeof val === "string" &&
      (val.includes("T") || val.match(/\d{2}:\d{2}/))
    ) {
      const date = new Date(val);
      if (!isNaN(date)) {
        const formattedDate = options.showDate
          ? date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "";

        const formattedTime = options.showTime
          ? date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })
          : "";

        if (options.showDate && options.showTime) {
          return `${formattedDate}, ${formattedTime}`;
        }
        return formattedDate || formattedTime;
      }
    }
    return val;
  };

  const fetchData = async (
    page = 1,
    startDate = null,
    endDate = null,
    rowsPerPageValue = null,
    shift = null
  ) => {
    setLoading(true);
    setError(null);

    try {
      const noOfRecords = rowsPerPageValue || pagination.rowsPerPage;
      const hopperParam = isHopper1 ? "hopper1" : "hopper2";

      console.log(`Fetching data for ${hopperParam}`);

      // Use imported API function
      const response = await fetchTurmericHistory({
        page,
        startDate,
        endDate,
        noOfRecords,
        hopper: hopperParam
      });

      if (
        response &&
        response.statusCode === 200 &&
        response.body &&
        response.body.success
      ) {
        const successData = response.body.success;
        console.log("Success data:", successData);

        const processedData = (successData.data || []).map((item, index) => {
          const parts = item.timestamp_range.split(" ");
          let dateStr = parts[0];
          let timeRange = "";
          let shift = "";
          let startDateObj = null;

          try {
            timeRange = `${parts[1]} ${parts[2]} to ${parts[5]} ${parts[6]}`;
            const [day, month, year] = parts[0].split("-");
            const formattedStart = `${month}-${day}-20${year} ${parts[1]} ${parts[2]}`;
            startDateObj = new Date(formattedStart);

            if (item.shift) {
              shift = item.shift === "A" ? "I" : item.shift === "B" ? "II" : item.shift;
            } else {
              const timeStr = parts[1] + " " + parts[2];
              let hour = parseInt(timeStr.split(":")[0]);
              const isPM = timeStr.includes("PM");
              if (isPM && hour !== 12) hour += 12;
              if (!isPM && hour === 12) hour = 0;
              shift = hour >= 6 && hour < 18 ? "I" : "II";
            }
          } catch (e) {
            console.error("Error processing timestamp:", e);
            timeRange = item.timestamp_range;
            shift = "Unknown";
            startDateObj = new Date();
          }

          const formattedDateTime = `${dateStr}, ${timeRange}`;
          const formattedDate = dateStr;
          const formattedTime = timeRange;

          const isCurrentHopper =
            (isHopper1 && item.hopper === "hopper1") ||
            (!isHopper1 && item.hopper === "hopper2");

          return {
            id: index + 1,
            dateTime: formattedDateTime,
            date: formattedDate,
            time: formattedTime,
            sackCount: item.sack_count || 0,
            grillCleaning: item.grill_cleaning_count || 0,
            grillPresence: item.grill_absent_count || 0,
            meshPresence: item.safety_mesh_absent_count || 0,
            actual_sack_count: item.actual_sack_count,
            shift: shift,
            dateObj: startDateObj,
            hopper: item.hopper,
            isCurrentHopper: isCurrentHopper,
            raw: item,
          };
        });


        // Sort by most recent first
        processedData.sort((a, b) => b.date - a.date);

        const currentHopperData = processedData.filter(
          (item) =>
            (isHopper1 && item.hopper === "hopper1") ||
            (!isHopper1 && item.hopper === "hopper2")
        );

        let finalData = currentHopperData.length > 0 ? currentHopperData : processedData;

        if (currentHopperData.length === 0 && processedData.length > 0) {
          console.warn(
            `No data found for ${isHopper1 ? "hopper1" : "hopper2"}, showing all available data instead`
          );
        }

        // Pre-populate actualCountsRef with existing actual counts
        actualCountsRef.current = {};
        finalData.forEach(item => {
          if (item.actual_sack_count != null && item.actual_sack_count !== "") {
            const key = `${item.date}_${item.time}`;
            actualCountsRef.current[key] = String(item.actual_sack_count);
          }
        });

        setData(finalData);
        setOriginalData(processedData);

        if (shift) {
          const filtered = finalData.filter((item) => item.shift === shift);
          setData(filtered);
        }

        setPagination({
          currentPage: successData.page_no || 1,
          totalPages: successData.total_pages || 1,
          totalRecords: successData.total_records || 0,
          rowsPerPage: rowsPerPageValue || pagination.rowsPerPage,
        });
      } else {
        throw new Error("Unexpected API response format");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data. Please try again later.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Refactored fetchMetricsData function
  const fetchMetricsData = async (startDate, endDate) => {
    const metricsLoading = true;
    let metricsError = null;

    try {

      // Use imported API function
      const response = await fetchTurmericSummary(startDate, endDate);
      console.log(`Fetching metrics data`, response);
      // Alternative way using default export:
      // const response = await turmericApi.fetchSummary(startDate, endDate);

      if (
        response &&
        response.statusCode === 200 &&
        response.body &&
        response.body.success
      ) {
        const metricsData = response.body.success;
        console.log("Success metrics data:", metricsData);

        const hopper1Data = metricsData.hopper1 || {};
        const hopper2Data = metricsData.hopper2 || {};

        const hopper1UnsafeEvents = (hopper1Data.unsafe_event || []);
        const hopper2UnsafeEvents = (hopper2Data.unsafe_event || []);

        const getStatusForHopper = (hopperData, type) => {
          if (hopperData.last_lid_presence === "present") {
            return { status: true, displayText: "Lid Closed", isLidClose: true };
          }

          if (type === "grill") {
            return {
              status: hopperData.last_grill_presence === "present",
              displayText: hopperData.last_grill_presence === "present" ? "Present" : "Removed",
              isLidClose: false
            };
          } else if (type === "mesh") {
            return {
              status: hopperData.last_safety_mesh_presence === "present",
              displayText: hopperData.last_safety_mesh_presence === "present" ? "Present" : "Removed",
              isLidClose: false
            };
          }

          return { status: false, displayText: "Unknown", isLidClose: false };
        };

        setMetrics({
          hopper1: {
            sackCount: hopper1Data.total_sack_count?.toString() || "0",
            grillCleaningTime: hopper1Data.last_grill_cleaning_time || "No data",
            grillCleaningImage: hopper1Data.last_grill_cleaning_image || null,
            grillStatus: getStatusForHopper(hopper1Data, "grill"),
            meshStatus: getStatusForHopper(hopper1Data, "mesh"),
            lidPresence: hopper1Data.last_lid_presence,
            unsafeEvents: hopper1UnsafeEvents
          },
          hopper2: {
            sackCount: hopper2Data.total_sack_count?.toString() || "0",
            grillCleaningTime: hopper2Data.last_grill_cleaning_time || "No data",
            grillCleaningImage: hopper2Data.last_grill_cleaning_image || null,
            grillStatus: getStatusForHopper(hopper2Data, "grill"),
            meshStatus: getStatusForHopper(hopper2Data, "mesh"),
            lidPresence: hopper2Data.last_lid_presence,
            unsafeEvents: hopper2UnsafeEvents
          },
        });

        setUnsafeEvents({
          hopper1: hopper1UnsafeEvents,
          hopper2: hopper2UnsafeEvents
        });

        setTurmericCleaningHistory({
          hopper1: (hopper1Data?.cleaning_history).reverse() || [],
          hopper2: (hopper2Data?.cleaning_history).reverse() || []
        });
      } else {
        throw new Error("Unexpected metrics API response format");
      }
    } catch (err) {
      console.error("Error fetching metrics data:", err);
      metricsError = "Failed to fetch metrics data. Please try again later.";
    }
  };

  // Update the useEffect to call fetchMetricsData with fetchData
  useEffect(() => {
    // Set default date range to today (start and end)
    const today = new Date();
    setDateRange([today, today]);

    // Fetch both table data and metrics data
    fetchData(1, today, today);
    fetchMetricsData(today, today);
  }, []);

  // Fetch data when hopper selection changes
  useEffect(() => {
    // Set default date range to today (start and end)
    const today = new Date();
    setDateRange([today, today]);

    // Call both APIs with today's date
    fetchData(1, today, today);
    fetchMetricsData(today, today);
  }, []);

  useEffect(() => {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      // Reset to page 1 when switching hoppers to ensure we get proper results
      fetchData(
        1,
        dateRange[0],
        dateRange[1],
        pagination.rowsPerPage,
        shiftFilter
      );

      // Show toast or notification if needed
      // console.log(`Switched to ${isHopper1 ? "Hopper1" : "Hopper2"}`);
    }
  }, [isHopper1]);

  useEffect(() => {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      // Auto apply filter when date range changes
      fetchData(1, dateRange[0], dateRange[1], pagination.rowsPerPage, shiftFilter);
      fetchMetricsData(dateRange[0], dateRange[1]);
    }
  }, [dateRange]);

  const applyDateFilter = () => {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      fetchData(
        1,
        dateRange[0],
        dateRange[1],
        pagination.rowsPerPage,
        shiftFilter
      );
      fetchMetricsData(dateRange[0], dateRange[1]);
    }
  };

  const tableHeadingStyle = {
    fontWeight: "bold",
    color: "#007BFF",
    margin: "auto 0px",
  };

  const tableContainerStyle = {
    width: "100%",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    minHeight: "100px",
    marginBottom: "1rem",
  };

  const dateFilterContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "start",
    alignItems: "center",
    padding: "0 15px",
    borderRadius: "8px",
    marginBottom: "20px",
    gap: "15px",
  };

  function MetricCard({ title, value, icon, isTimestamp = false }) {
    return (
      <div className="metric-card">
        <div className="p-3">
          <div className="metric-title">{title}</div>
          <div className="d-flex align-items-center justify-content-between">
            <div className={`metric-value ${isTimestamp ? "timestamp" : ""}`}>
              {value}
            </div>
            <div>{icon}</div>
          </div>
        </div>
      </div>
    );
  }

  function StatusCard({ title, statusData, icon, isEyeIcon }) {
    // statusData now contains: { status, displayText, isLidClose }
    const { status, displayText, isLidClose } = statusData;

    // Determine color based on status and lid close
    const getStatusColor = () => {
      if (isLidClose) {
        return "lid-close"; // Special color for lid close
      }
      return status ? "success" : "danger";
    };

    const statusColor = getStatusColor();

    return (
      <div className="status-card">
        {/* Gradient corner */}
        <div className={`status-gradient ${statusColor}`}>
          {/* <div className="status-icon-corner">
          {status ? (
            <CheckCircle className="icon-sm" />
          ) : (
            <XCircle className="icon-sm" />
          )}
        </div> */}
        </div>

        <div
          className="p-3"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="d-flex align-items-center">
            <div
              className={`status-icon-wrapper ${statusColor}`}
            >
              {icon}
            </div>
            <div>
              {/* <div className="status-title">{title}</div> */}
              {!isLidClose && (
                <div className="status-title">{title}</div>
              )}
              <div className={`status-value ${statusColor}`}>
                {displayText}
              </div>
            </div>
          </div>
          {isEyeIcon && (
            <div
              style={{ width: "40px", height: "40px", marginRight: "2rem" }}
            ></div>
          )}
        </div>
      </div>
    );
  }

  const handleCleaningHistoryClick = (component, type) => {
    setCurrentCleaningComponent(component);
    setCurrentCleaningType(type);
    setShowCleaningHistoryModal(true);
    setShowTurmericModal(true);
  };

  // Handle pagination change
  const onPageChange = (event) => {
    const newPage = event.page + 1;
    const newRowsPerPage = event.rows;

    setPagination((prev) => ({
      ...prev,
      currentPage: newPage,
      rowsPerPage: newRowsPerPage,
    }));

    fetchData(newPage, dateRange[0], dateRange[1], newRowsPerPage, shiftFilter);
  };

  return (
    <div
      className="col-lg-12"
      style={{
        maxHeight: "90vh",
        overflowY: "scroll",
        overflowX: "hidden",
        width: "88vw",
      }}
    >
      <InfoHeader />
      <div className="row g-3 mb-3">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h2 className="fs-5 fw-semibold mb-0">Turmeric</h2>
        </div>
        {/* Date Range Filter Section */}
        <div style={dateFilterContainerStyle}>
          <div className="d-flex align-items-center">
            <FiCalendar className="me-2" size={18} />
            <span className="fw-semibold">Filter by Date Range:</span>
          </div>
          <div className="d-flex flex-wrap align-items-center gap-2">
            <Calendar
              value={dateRange}
              onChange={(e) => {
                setDateRange(e.value);
                // Auto close calendar after selection
                if (e.value && e.value.length === 2 && e.value[0] && e.value[1]) {
                  // Small delay to ensure the calendar closes properly
                  setTimeout(() => {
                    const calendarElement = document.querySelector('.p-calendar');
                    if (calendarElement) {
                      const inputElement = calendarElement.querySelector('input');
                      if (inputElement) {
                        inputElement.blur(); // This will close the calendar
                      }
                    }
                  }, 100);
                }
              }}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select Date Range"
              maxDate={new Date()}
              className="p-calendar-range"
              dateFormat="dd/mm/yy"
              hideOnRangeSelection={true} // This prop helps auto-close
            />

            <Button
              label="Apply Filter"
              icon="pi pi-filter"
              onClick={applyDateFilter}
              disabled={loading}
              className="p-button-md p-button-primary"
            />
            <Button
              // label="Clear Filter"
              icon="pi pi-times"
              onClick={() => {
                // Reset to today's date
                const today = new Date();
                setDateRange([today, today]);
                setShiftFilter(""); // Also clear shift filter
              }}
              className="p-button-md p-button-primary "
              disabled={loading}
            />
            <Button
              label={loading ? "Downloading..." : "Cleaning Activity"}
              icon={loading ? "pi pi-spin pi-spinner" : "pi pi-download"}
              onClick={handleDownloadExcel}
              disabled={loading || !dateRange[0] || !dateRange[1]}
              className="p-button-md p-button-primery"
              style={{
                marginLeft: '10px',
                minWidth: '200px'
              }}
              tooltip={
                !dateRange[0] || !dateRange[1]
                  ? "Please select a date range first"
                  : "Download cleaning activity data as Excel file for hopper1 and hopper2"
              }
              tooltipOptions={{ position: 'top' }}
            />
            <Button
              label="Unsafe Events"
              icon="pi pi-download"
              onClick={handleDownloadUnsafeEventsExcel}
              disabled={loading || !dateRange[0] || !dateRange[1]}
              className="p-button-md p-button-primery"
              style={{
                marginLeft: '10px',
                minWidth: '200px'
              }}
              tooltip={
                !dateRange[0] || !dateRange[1]
                  ? "Please select a date range first"
                  : "Download unsafe events data as Excel file for hopper1 and hopper2"
              }
              tooltipOptions={{ position: 'top' }}
            />
          </div>

          <div style={{ ...tableHeadingStyle }}>
            {/* <div className="small text-muted mt-1">
              Showing data for: {getDateRangeText()}
              {shiftFilter ? ` | Shift: ${shiftFilter}` : " "}
            </div> */}
          </div>
        </div>
        <div
          className="col-12"
          style={{
            display: "flex",
            width: "99%",
            margin: "0 auto",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 0.5rem",
            }}
          >
            <h6
              className="fw-medium col-6 p-2"
              style={{ display: "flex", flexDirection: "row" }}
            >
              Hopper 1
            </h6>
            <div>
              <Button
                style={{ backgroundColor: "#e03730", border: "none" }}
                onClick={() => {
                  setCurrentHopper("hopper1");
                  setShowUnsafeModal(true);
                  setActiveIndex(0);
                  setCurrentRtcComponent(null);
                }}
              >
                Unsafe Events - {metrics.hopper1.unsafeEvents.length}
              </Button>
              <FaHistory
                className="history-icon"
                style={{
                  cursor: "pointer",
                  color: "#6c757d",
                  fontSize: "2rem",
                  marginLeft: "1rem",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCleaningHistoryClick("hopper1", "turmeric");
                }}
                title="View magnetic grill cleaning history"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 0.5rem",
            }}
          >
            <h6
              className="fw-medium col-6 p-2"
              style={{ display: "flex", flexDirection: "row" }}
            >
              Hopper 2
            </h6>
            <div>
              <Button
                style={{ backgroundColor: "#e03730", border: "none" }}
                onClick={() => {
                  setCurrentHopper("hopper2");
                  setShowUnsafeModal(true);
                  setActiveIndex(0);
                  setCurrentRtcComponent(null);
                }}
              >
                Unsafe Events - {metrics.hopper2.unsafeEvents.length}
              </Button>
              <FaHistory
                className="history-icon"
                style={{
                  cursor: "pointer",
                  color: "#6c757d",
                  fontSize: "2rem",
                  marginLeft: "1rem",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCleaningHistoryClick("hopper2", "turmeric");
                }}
                title="View magnetic grill cleaning history"
              />
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="col-md-12">
            <MetricCard
              title="Sack emptying count"
              value={metrics.hopper1.sackCount}
              icon={<FiShoppingBag className="metric-icon yellow" />}
            />
          </div>
          <div className="col-md-12" onClick={(e) => {
            e.stopPropagation();
            setCurrentHopper("hopper1");
            setCleaningImage(metrics.hopper1?.grillCleaningImage)
            // setShowCleaningModal(true)
            setCurrentCleaningComponent("hopper1")
            setShowTurmericModal(true)
          }
          }>
            <MetricCard
              title="Magnetic grill last cleaning (CCP)"
              value={metrics.hopper1.grillCleaningTime}
              icon={<FaMagnet className="metric-icon yellow" />}
              isTimestamp
            />
          </div>
        </div>
        <div className="col-3">
          <div className="col-md-12">
            <StatusCard
              title="Magnetic grill"
              statusData={metrics.hopper1.grillStatus}
              icon={<FiShield className="status-icon" />}
            />
          </div>
          <div className="col-md-12">
            <StatusCard
              title="Safety mesh"
              statusData={metrics.hopper1.meshStatus}
              icon={<SiTraefikmesh className="status-icon" />}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="col-md-12">
            <MetricCard
              title="Sack emptying count"
              value={metrics.hopper2.sackCount}
              icon={<FiShoppingBag className="metric-icon yellow" />}
            />
          </div>
          <div className="col-md-12" onClick={(e) => {
            e.stopPropagation();
            setCurrentHopper("hopper2");
            setCleaningImage(metrics.hopper2?.grillCleaningImage)
            setCurrentCleaningComponent("hopper2")
            // setShowCleaningModal(true)
            setShowTurmericModal(true)
          }
          }>

            <MetricCard
              title="Magnetic grill last cleaning (CCP)"
              value={metrics.hopper2.grillCleaningTime}
              icon={<FaMagnet className="metric-icon yellow" />}
              isTimestamp
            />
          </div>
        </div>
        <div className="col-3">
          <div className="col-md-12">
            <StatusCard
              title="Magnetic grill"
              statusData={metrics.hopper2.grillStatus}
              icon={<FiShield className="status-icon" />}
            />
          </div>
          <div className="col-md-12">
            <StatusCard
              title="Safety mesh"
              statusData={metrics.hopper2.meshStatus}
              icon={<SiTraefikmesh className="status-icon" />}
            />
          </div>
        </div>
      </div>

      <div style={tableContainerStyle}>
        <div
          style={{
            display: "flex",
            marginBottom: "1rem",
          }}
        >
          <div
            className="toggle-container"
            style={{
              display: "flex",
              borderRadius: "28px",
              overflow: "hidden",
              border: "1px solid #007BFF",
              width: "220px",
              height: "40px",
              boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
            }}
          >
            <button
              onClick={() => setIsHopper1(true)}
              style={{
                padding: "0 12px",
                border: "none",
                background: isHopper1 ? "#007BFF" : "#fff",
                color: isHopper1 ? "#fff" : "#007BFF",
                cursor: "pointer",
                fontWeight: "600",
                flex: "1",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              Hopper1
            </button>
            <button
              onClick={() => setIsHopper1(false)}
              style={{
                padding: "0 12px",
                border: "none",
                background: !isHopper1 ? "#007BFF" : "#fff",
                color: !isHopper1 ? "#fff" : "#007BFF",
                cursor: "pointer",
                fontWeight: "600",
                flex: "1",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              Hopper2
            </button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <h4 style={tableHeadingStyle}>Turmeric Data</h4>
          </div>
          <div className="ms-auto d-flex align-items-center">
            <span className="me-2" style={{ width: "7rem" }}>
              Filter by Shift:
            </span>
            <Dropdown
              value={shiftFilter}
              options={[
                { label: "All Shifts", value: "" },
                { label: "Shift I", value: "I" },
                { label: "Shift II", value: "II" },
              ]}
              onChange={(e) => {
                setShiftFilter(e.value);
                // Apply shift filter immediately
                if (dateRange && dateRange.length === 2) {
                  fetchData(
                    1,
                    dateRange[0],
                    dateRange[1],
                    pagination.rowsPerPage,
                    e.value
                  );
                }
              }}
              placeholder="Select Shift"
              className="w-auto"
            />
          </div>
        </div>

        {/* DataTable with API data */}
        <DataTable
          value={data}
          scrollable
          scrollHeight="300px"
          className="p-datatable-sm p-datatable-striped"
          paginator
          rows={pagination.rowsPerPage}
          rowsPerPageOptions={[10, 30, 50]}
          totalRecords={pagination.totalRecords}
          onPage={onPageChange}
          loading={loading}
          emptyMessage="No records found"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          <Column field="id" header="Sr. No." style={{ width: "5%" }} bodyStyle={{ textAlign: "right" }} />
          <Column field="date" header="Date" style={{ width: "10%" }} />
          <Column field="time" header="Time" style={{ width: "13%" }} />
          <Column
            field="shift"
            header="Shift"
            style={{ width: "7%" }}
            bodyStyle={{
              backgroundColor: "rgb(214, 249, 255)",
              textAlign: "center",
            }}
          />
          <Column
            field="unsafe_events"
            header="Unsafe Events"
            style={{ width: "10%" }}
            bodyStyle={{
              backgroundColor: "rgba(233, 236, 239, 0.7)",
              textAlign: "right",
            }}
          />
          <Column
            field="sackCount"
            header="Sack Emptying Count"
            style={{ width: "13%" }}
            bodyStyle={{
              backgroundColor: "rgba(233, 236, 239, 0.7)",
              textAlign: "right",
            }}
          />
          <Column
            header="Actual Sack Count"
            style={{ width: "13%" }}
            body={(rowData) => (
              <input
                key={`${rowData.date}_${rowData.time}`}
                type="text"
                inputMode="numeric"
                defaultValue={rowData.actual_sack_count != null && rowData.actual_sack_count !== "" ? rowData.actual_sack_count : ""}
                onChange={(e) =>
                  handleActualCountChange(
                    `${rowData.date}_${rowData.time}`,
                    e.target.value
                  )
                }
                placeholder="Enter count"
                style={{
                  width: "100%",
                  padding: "4px 8px",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  textAlign: "right",
                }}
              />
            )}
          />
          <Column
            header="Action"
            style={{ width: "7%" }}
            bodyStyle={{ textAlign: "center" }}
            body={(rowData) => (
              <RowSaveButton
                key={`${rowData.date}_${rowData.time}`}
                rowKey={`${rowData.date}_${rowData.time}`}
                saveCallbacksRef={saveCallbacksRef}
                onSave={() => handleSaveActualCount(rowData)}
                hasExistingValue={rowData.actual_sack_count != null && rowData.actual_sack_count !== ""}
              />
            )}
          />
        </DataTable>
      </div>
      <UnsafeEventsModal
        showModal={showUnsafeModal}
        onHide={() => {
          setShowUnsafeModal(false);
          setActiveIndex(0);
        }}
        currentHopper={currentHopper}
        currentRtcComponent={currentRtcComponent}
        unsafeEvents={unsafeEvents}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        formatIfTimestamp={formatIfTimestamp}
      />
      {/* <CleaningHistoryModal
        showModal={showCleaningHistoryModal}
        onHide={() => {
          setShowCleaningHistoryModal(false);
          setShowTurmericModal(false);
          setCurrentCleaningComponent(null);
          setCurrentCleaningType(null);
        }}
        currentComponent={currentCleaningComponent}
        componentType={currentCleaningType}
        formatIfTimestamp={formatIfTimestamp}
      /> */}
      <CleaningHistoryModal
        showModal={showTurmericModal}
        onHide={() => setShowTurmericModal(false)}
        currentComponent={currentCleaningComponent}
        turmericCleaningHistory={turmericCleaningHistory}
        // rtcCleaningHistory={rtcCleaningHistory}
        cleaningType="turmeric"
      />
      <Modal
        show={showCleaningModal}
        onHide={() => setShowCleaningModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {currentHopper ? "Turmeric" : "RTC"} - {''}
            {currentHopper === "hopper1" ? "Hopper 1" : "Hopper 2"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="carousel-container">
            {currentHopper ? (
              // Turmeric unsafe events
              <>
                {/* <h5>{currentHopper === "hopper1" ? "Hopper 1" : "Hopper 2"}</h5> */}
                {/* Serial Number Display */}
                {cleaning_image ? (

                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "2rem auto",
                    }}
                  >
                    <img
                      src={cleaning_image}
                      alt={`Cleaning Image`}
                      className="img-fluid"
                    />
                  </div>
                ) : (<></>)}

              </>
            ) : (
              <></>
            )}
          </div>
        </Modal.Body>
      </Modal>

    </div>
  );
}

export default Turmeric;
